import { useEffect, useState } from "react";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Stats from "@/sections/Stats";
import Services from "@/sections/Services";
import Shop from "@/sections/Shop";
import Calculator from "@/sections/Calculator";
import Process from "@/sections/Process";
import WhyUs from "@/sections/WhyUs";
import FleetForm from "@/sections/FleetForm";
import Social from "@/sections/Social";
import Footer from "@/sections/Footer";
import StickyCTA from "@/sections/StickyCTA";
import CartDrawer from "@/sections/CartDrawer";

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 40);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen overflow-x-clip bg-[#F0F1F5] text-gray-900 selection:bg-violet-500/40 pb-24 md:pb-0"
    >
      <Navbar scrolled={scrolled} />
      <Hero />
      <Stats />
      <div className="cv-auto"><Services /></div>
      <div className="cv-auto"><Shop /></div>
      <div className="cv-auto"><Calculator /></div>
      <div className="cv-auto"><Process /></div>
      <div className="cv-auto"><WhyUs /></div>
      <div className="cv-auto"><FleetForm /></div>
      <div className="cv-auto"><Social /></div>
      <Footer />
      <StickyCTA />
      <CartDrawer />
    </main>
  );
}
